import AppRecord from './AppRecord.js'

class IssueTaxStructure extends AppRecord {
}
export default IssueTaxStructure
